import {stringIsNull} from 'utils'

export function resolveField(htmlContent:string,data?:any){
    if(stringIsNull(htmlContent)) return '';

    let arr = htmlContent.split('${');
    let arrLength = arr.length;
    if(arrLength===1) return htmlContent;

    for(let i=1 ; i< arrLength ; i++){
        if(i%2===1){
            let field = getField(arr[i]);
            if(field!==''){
                let fieldValue = data[field] || '';
                arr[i] = arr[i].replace(field+'}',fieldValue);
            }
        }
    }
    return arr.join('');
}

const getField = (fieldString:string) =>{
    if(fieldString.indexOf('}') === -1) return '';
    return fieldString.substr(0,fieldString.indexOf('}'))
}


// WEBPACK FOOTER //
// ./src/modules/modeling/utils.ts